import React from 'react';
import { connect } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
//local imports
import LeftMenu from '../AppLayout/leftMenu';
import { style } from '../../Styles/theme';
import Discussions from './discussion';
import DiscussionReportView from './discussionReport';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: style.backgroundColor._lightWhite
  },
  cardGrid: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(8),
  },
}));

function DiscussionBoard(props) {
  const classes = useStyles();

  const getRenderView = () => {
    if(props.match.params.discussionId){
      return(
        <DiscussionReportView history={props.history} match={props.match}/>
      )
    }else{
      return <Discussions match={props.match} history={props.history}/>
    }
  }

  return (
    <div className={classes.root}>
      <React.Fragment>
        <CssBaseline />
        <main>
          <Container className={classes.cardGrid} maxWidth="md">
            <Grid item style={{ maxWidth: '14%', flexBasis: '14%' }}>
              <LeftMenu history={props.history} />
            </Grid>
          </Container>
        </main>
        <div>
          {getRenderView()}
        </div>
      </React.Fragment>
    </div>
  );
}
const mapStateToProps = state => {
  return {}
}

export default connect(
  mapStateToProps, {}
)(DiscussionBoard);